import React from "react";
import useForm from "hook/useForm";
import Field from "components/Form/Field";
import { STATUS } from "reducers/formReducer";
import classNames from "lib/classNames";

export default function Form({
  id,
  fields,
  defaultValues: initialValues = null,
}) {
  const defaultValues = Object.keys(fields).reduce((acc, curr) => {
    acc[curr] = initialValues?.[curr] || null;
    return acc;
  }, {});
  const { captchaRef, state, errors, control, register, submit } = useForm(
    id,
    defaultValues
  );

  return (
    <form id={id} className="flex flex-col gap-8" onSubmit={submit}>
      {Object.keys(fields).map((key, index) => {
        const field = fields[key];
        const fieldName = field["#webform_key"] || null;

        return (
          <Field
            key={fieldName || index}
            captchaRef={captchaRef}
            field={field}
            register={register}
            control={control}
            errors={errors}
          />
        );
      })}
      {(state.status === STATUS.SUCCESS || state.status === STATUS.ERROR) && (
        <div
          role="alert"
          className={classNames(
            "block font-semibold",
            state.status === STATUS.SUCCESS && "text-green-500",
            state.status === STATUS.ERROR && "text-red-500"
          )}
        >
          {state.message}
        </div>
      )}
    </form>
  );
}
